import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: center;
  align-items: center;
  
  img{
    width: 320px;
  }
`;
